import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SpinnerService } from './services/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'frontend';
  blankRequested = false;
  isLoading = false;
  deferredPrompt: any;
  showInstallPopup: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
  ) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.blankRequested = route.root.firstChild.snapshot.data['blank'] ? true : false;
      }
    });
  }

  async ngOnInit() {
    this.spinnerService.loaderState$.subscribe((state: boolean) => {
      this.isLoading = state;
      this.cdr.detectChanges();
    });
    // this.checkInstallability();
  }

  checkInstallability() {
    if (!this.isStandaloneMode()) {
      window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault(); 
        this.deferredPrompt = event;  
        console.log('beforeinstallprompt event received');
      });
      if (this.isMobile()) {
        console.log("Mobile detected");
        this.showMobileInstallPopup();
      } else if (this.isDesktop()) {
        console.log("Desktop detected");
        this.showInstallPopup = true; 
      }
    } else {
      console.log("App is installed in standalone mode.");
    }
  }

  isMobile(): boolean {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

  isDesktop(): boolean {
    return /Windows|Mac/i.test(navigator.userAgent) && !/iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  onInstallClick() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt(); 
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null; 
        this.showInstallPopup = false; 
      });
    }
  }

  onIosInstallClick() {
    alert('To install on iOS, tap the Share icon → "Add to Home Screen".');
    this.showInstallPopup = false; 
  }

  showMobileInstallPopup() {
    if (this.isMobile()) {
      this.showInstallPopup = true;
    }
  }

  closeInstallPopup() {
    this.showInstallPopup = false;
  }

  isStandaloneMode(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
  }

  isIos(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  }
}
